<sn-direct-form
  [submitButtonName]="'common.invite' | t"
  [title]="'common.inviteMembers' | t"
  [isLoading]="isLoading"
  [isExternalAllowed]="true"
  [exceptionList]="memberIds"
  (send)="onFormSent($event)"
  [formErrors]="formErrors"
>
</sn-direct-form>
